import { NavLink } from 'react-router-dom'
import lcMosaic from '../../assets/lc-mosaic.svg'

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `font-sans font-bold uppercase text-[13px] px-1.5 py-0.5 transition-colors focus-ring-on-dark ${
    isActive ? 'bg-hazard text-ink' : 'hover:bg-hazard hover:text-ink'
  }`

export function Navbar() {
  return (
    <nav className="sticky top-0 z-50 bg-ink text-paper border-b border-ink">
      <div className="grid grid-cols-[auto_1fr_auto] items-center px-4 py-2 gap-4">
        <div className="flex items-center gap-2">
          <img src={lcMosaic} alt="" className="w-9 h-9 flex-shrink-0" />
          <span className="hidden md:inline font-display-cond uppercase text-[22px] leading-none">
            Cavalieri / dot dev
          </span>
        </div>

        <div className="hidden md:flex justify-center">
          <div className="flex items-center gap-1.5 bg-hazard text-ink font-mono text-[11px] uppercase px-2 py-0.5">
            <span className="w-1.5 h-1.5 rounded-full bg-ink animate-pulse inline-block" />
            LIVE · MMXXVI
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 md:gap-4">
          <NavLink to="/" end className={navLinkClass}>
            Home
          </NavLink>
          <NavLink to="/about" className={navLinkClass}>
            About
          </NavLink>
          <NavLink to="/projects" className={navLinkClass}>
            Work
          </NavLink>
          <a
            href="https://blog.luizcavalieri.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="font-sans font-bold uppercase text-[13px] px-1.5 py-0.5 hover:bg-hazard hover:text-ink transition-colors focus-ring-on-dark"
          >
            Writing
          </a>
          <NavLink to="/contact" className={navLinkClass}>
            Contact
          </NavLink>
        </div>
      </div>

      <div className="hidden md:flex justify-between items-center px-4 py-1 font-mono text-[11px] text-paper-2">
        <span>ISSUE No. 04</span>
        <span>SYDNEY · NSW · −33.8°</span>
        <span>ENG. MGR · NINE · PUBLISHING</span>
        <span>UPDATED THIS WEEK</span>
      </div>
    </nav>
  )
}
